export default __webpack_public_path__ + "static/media/Plissee 18 mm reversibel ausmessen front.95fa21fc.jpg";